
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const ProcessSection = () => {
  const steps = [
    {
      number: '01',
      title: 'Discovery',
      description: 'We begin with a comprehensive consultation to understand your goals, challenges, and vision.',
    },
    {
      number: '02',
      title: 'Strategy',
      description: 'Our team develops a tailored strategy aligned with your objectives and industry best practices.',
    },
    {
      number: '03',
      title: 'Execution',
      description: 'We implement solutions with precision, maintaining clear communication and quality standards.',
    },
    {
      number: '04',
      title: 'Optimization',
      description: 'Continuous monitoring, refinement, and support ensure sustained success and measurable results.',
    },
  ];

  return (
    <section className="py-24 lg:py-32 bg-warm-white">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <p className="font-inter text-xs uppercase tracking-widest text-taupe mb-4">
            Our Approach
          </p>
          <h2 className="font-playfair text-4xl lg:text-5xl font-semibold text-charcoal mb-6">
            A Proven Process for <em className="text-warm-gold">Success</em>
          </h2>
          <p className="font-inter text-lg text-charcoal/60 max-w-3xl mx-auto">
            Our structured methodology ensures every engagement delivers exceptional results through strategic planning and flawless execution.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 mb-16">
          {steps.map((step, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.1 }}
              className="relative"
            >
              <div className="font-playfair text-6xl font-semibold text-warm-gold/30 mb-4">
                {step.number}
              </div>
              <h3 className="font-inter text-xl font-bold text-charcoal mb-3">
                {step.title}
              </h3>
              <p className="font-inter text-base text-charcoal/70 leading-relaxed">
                {step.description}
              </p>
              {index < steps.length - 1 && (
                <div className="hidden lg:block absolute top-8 -right-4 w-8 h-px bg-warm-gold/30"></div>
              )}
            </motion.div>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6, delay: 0.4 }}
          className="text-center"
        >
          <Link
            to="/book-consultation"
            className="inline-flex items-center justify-center bg-warm-gold text-charcoal font-inter font-semibold px-8 py-4 rounded-full hover:bg-soft-bronze transition-all duration-300 cursor-pointer whitespace-nowrap"
          >
            Start Your Project
          </Link>
        </motion.div>
      </div>
    </section>
  );
};

export default ProcessSection;
